module.exports = __webpack_public_path__ + "assets/img/127b66d.9701a342.svg";